import React from "react";
import { useNavigate } from "react-router-dom";
import { shotsData } from "../helpers/projectListData";
import { motion } from "framer-motion";
import { gridContainterVariants, gridCubeVariants } from "../utilities/customHooks";

function Shots() {
  const navigate = useNavigate();
  return (
    <>
      <div className="section">
        <h2>
          🎭 <span>Exploration</span>
        </h2>
      </div>
      <motion.div variants={gridContainterVariants} initial="hidden" animate="show" className="section">
        {shotsData.map((shot, i) => {
          return (
            <motion.div variants={gridCubeVariants} className="shot" key={i} onClick={() => {
              navigate("/shot/" + i);
            }}>
              <div className="shot-img">
                <img src={shot.thumbnail} alt="Shot" />
              </div>
              <p>{shot.name}</p>
              <p className="tag">{shot.category}</p>
              {shot.comp}
            </motion.div>
          );
        })}
      </motion.div>
    </>
  );
}

export default Shots;
